import { render, staticRenderFns } from "./Journaleintraege.vue?vue&type=template&id=4b66552e"
import script from "./Journaleintraege.vue?vue&type=script&lang=js"
export * from "./Journaleintraege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports